import React from "react";

export default function ServiceFAQSBox({ faqsData }) {
  return (
    <>
      <div className="accordion-item mb-2 wow fadeInUp" data-wow-delay=".5s">
        <h5 className="accordion-header">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#faq${faqsData.id}`}
            aria-expanded="false"
            aria-controls={`faq${faqsData.id}`}
          >
            {faqsData?.title || ""}
          </button>
        </h5>
        <div
          id={`faq${faqsData.id}`}
          className="accordion-collapse collapse"
          data-bs-parent="#accordion"
        >
          <div className="accordion-body">{faqsData?.tagline || ""}</div>
        </div>
      </div>
    </>
  );
}
